import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';

const keysToRemove = ['tax_amount', 'charge_amount', 'discount_amount'];

export const editProducts = async (payload) => {
  const { data } = await apiClient.put(`/products/${payload.product_id}`, payload);
  return data;
};

export const useEditProductHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: editProducts,
    onSuccess: () => {
      dispatch(showSnackbar({ message: 'Product updated successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const onSubmit = async (data) => {
    const cleanedData = Object.fromEntries(Object.entries(data).filter(([key]) => !keysToRemove.includes(key)));
    mutation.mutate(cleanedData);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onEdit: onSubmit,
  };
};
